
                export default function (Component) {
                    Component.__source = "library/components/VabApp/index.vue"
                }
            